import React, { type ComponentProps } from 'react';
import { View, Platform, StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { ScreenHeaderButton } from '../ScreenHeaderButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderPointsButton = (props: Props) => {
  const { accessibilityLabel, points, text, ...restProps } = props;

  const buttonAccessibilityLabel = accessibilityLabel ?? [points, text].filter(Boolean).join(' ');

  return (
    <ScreenHeaderButton.Container
      accessibilityLabel={buttonAccessibilityLabel}
      palette="translucent"
      {...restProps}
    >
      <ScreenHeaderButton.Icon name="IconSgRewardKaleFill" />

      <View style={styles.textContainer}>
        {points ? (
          <ScreenHeaderButton.Title color={theme.colors.WHITE}>{points}</ScreenHeaderButton.Title>
        ) : null}

        {text ? (
          <ScreenHeaderButton.Title color={theme.colors.WHITE} bold={!points}>
            {text}
          </ScreenHeaderButton.Title>
        ) : null}
      </View>
    </ScreenHeaderButton.Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  textContainer: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: theme.spacing['1'],

    // NOTE: This improves baseline alignment with the icon
    marginTop: Platform.select({ web: 3, native: 2 }),
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  points?: string;
  text?: string;
} & Omit<ComponentProps<typeof ScreenHeaderButton.Container>, 'children' | 'palette'>;
